import React, { useRef, useState } from 'react';

import LabelSubscriberActionMenu from './LabelSubscriberActionMenu';
import LabelSubscribersListChunkMobile from './LabelSubscribersListChunkMobile';
import { LabelSubscription, useLabelSubscribersContext } from './LabelSubscribersContext';
import useNearBottomScroll from 'hooks/useNearBottom';

const LabelSubscribersListMobile = () => {
  const { page, getSubscriberActions, setUrlQuery, fetching, pageInfo } =
    useLabelSubscribersContext();

  const [selectedSubscriber, setSelectedSubscriber] = useState<LabelSubscription | null>(
    null
  );
  const actions = selectedSubscriber ? getSubscriberActions(selectedSubscriber) : [];

  const setPage = (p: number) => setUrlQuery({ page: p });
  const pageRef = useRef(page);
  pageRef.current = page;
  useNearBottomScroll({
    callback: () => setPage(pageRef.current + 1),
    disabled: fetching || !pageInfo?.hasNextPage
  });

  // Because I could not get URQL's graphcache to support pagination, we have to load each "page" as
  // individual components to open a query to that specific page of data. Hacky way of managing cache
  // invalidation... We'll change this if we get graphcache working.
  const pageIndexArray = Array.from(Array(page).keys());

  return (
    <div>
      {selectedSubscriber && (
        <LabelSubscriberActionMenu
          subscription={selectedSubscriber}
          actions={actions}
          isOpen={!!selectedSubscriber}
          close={() => setSelectedSubscriber(null)}
        />
      )}

      {pageIndexArray.map(pageIndex => (
        <LabelSubscribersListChunkMobile
          key={pageIndex}
          page={pageIndex + 1}
          setSelectedSubscriber={setSelectedSubscriber}
        />
      ))}

      {pageInfo && !pageInfo.hasNextPage && (
        <div className="text-center text-gray-500 text-sm mt-4">
          Showing {pageInfo.nodeCount} Subscribers
        </div>
      )}
    </div>
  );
};

export default LabelSubscribersListMobile;
